// extracted by mini-css-extract-plugin
export default {"faqHeading":"Faq_faqHeading__-3KPb","faqItem":"Faq_faqItem__hoXMQ","faqContainer":"Faq_faqContainer__WeqZ9"};